
import { Component, Vue, Prop } from "vue-property-decorator";
import MainHeader from "@/components/main-header.vue";
import NavLeft from "@/components/nav-left.vue";
import Empty from "@/components/empty.vue";
import {
  GetPlanData,
  GetPlanTem,
  PostAddBingzhong,
  PostAddBingzhongTem,
  GetTemDetail,
  GetExportManagementAll,
  DeleteExportManagement,
  GetExportTem,
  PatchBingzhongTem,
  PatchBingzhong,
} from "@/request/common";
@Component({
  components: {
    MainHeader,
    NavLeft,
    Empty,
  },
})
export default class Name extends Vue {
  private data: any = [];
  private ifShowAddPlan: any = false;
  private ifShowAdd: any = false;
  private ifShowAddtem: any = false;
  private editData: any = {
    codes: [],
    plans: [],
  };
  private planData: any = {};
  private plans: any = [];
  private temData: any = {};
  private getCodes(items: any) {
    let text: any = "";
    items.forEach((ele: any) => {
      if (text) {
        text += "、";
      }
      text += ele.code;
    });
    return text;
  }
  private getRange(items: any) {
    let text: any = "";
    items.forEach((ele: any) => {
      if (text) {
        text += "、";
      }
      text += ele.name;
    });
    return text;
  }
  private delBing(item: any) {
    this.$confirm("您是否确定删除当前病种？", "删除", {
      customClass: "commonConfirm",
    }).then(() => {
      const loading = this.$loading({
        lock: true,
        text: "加载中……",
        spinner: "el-icon-loading",
        customClass: "loadClass",
        background: "rgba(255, 255, 255, 0.7)",
      });
      DeleteExportManagement(this, item.id, loading).then((res: any) => {
        this.$message.success("删除成功");
        this.getList();
      });
    });
  }
  private delTem(index: any) {
    this.$confirm("您是否确定删除当前内容？", "删除", {
      customClass: "commonConfirm",
    }).then(() => {
      this.temData.headers.splice(index, 1);
    });
  }
  private addOneTem() {
    this.temData.headers.push({
      key: "",
      title: "",
      origin: "",
      is_time_key: false,
    });
  }
  private changeRadio(index: any) {
    this.temData.headers.forEach((ele: any, i: any) => {
      if (index == i) {
        ele.is_time_key = !ele.is_time_key;
      } else {
        ele.is_time_key = false;
      }
    });
  }
  private openAddTem(items: any, index: any, item: any, i: any) {
    if (item.export_template_id) {
      const loading = this.$loading({
        lock: true,
        text: "加载中……",
        spinner: "el-icon-loading",
        customClass: "loadClass",
        background: "rgba(255, 255, 255, 0.7)",
      });
      GetExportTem(this, item.export_template_id, loading).then((res: any) => {
        // this.temData = ;
        this.temData = {
          plan: items,
          index: index,
          template: item,
          i: i,
          id: res.data.id,
          headers: res.data.headers,
        };
        this.ifShowAddtem = true;
      });
    } else {
      this.temData = {
        plan: items,
        index: index,
        template: item,
        i: i,
        headers: [],
      };
      this.temData.template.id = this.temData.template.template_id;
      this.ifShowAddtem = true;
    }
  }
  private addTemSure() {
    // 编码和表头名称需要必填
    for (let i: any = 0; i < this.temData.headers.length; i++) {
      const d = this.temData.headers[i];
      if (!d.key || !d.title) {
        this.$message.warning("您还有必填项未填");
        return;
      }
    }
    if (this.temData.id) {
      const params: any = {
        headers: this.temData.headers,
      };
      PatchBingzhongTem(this, this.temData.id, params).then((res: any) => {
        const id = res.data.id;
        this.editData.plans[this.temData.index].children[
          this.temData.i
        ].export_template_id = id;
        this.ifShowAddtem = false;
      });
    } else {
      const params: any = {
        plan: {
          id: this.temData.plan.plan_id,
        },
        template: {
          id: this.temData.template.id,
        },
        headers: this.temData.headers,
      };
      PostAddBingzhongTem(this, params).then((res: any) => {
        const id = res.data.id;
        this.editData.plans[this.temData.index].children[
          this.temData.i
        ].export_template_id = id;
        this.ifShowAddtem = false;
      });
    }
  }
  private exportData() {
    console.log(this.temData);
    this.$confirm("导入后会覆盖当前内容，确定一键导入吗？", "一键导入", {
      customClass: "commonConfirm",
    }).then(() => {
      const loading = this.$loading({
        lock: true,
        text: "加载中……",
        spinner: "el-icon-loading",
        customClass: "loadClass",
        background: "rgba(255, 255, 255, 0.7)",
      });
      GetTemDetail(
        this,
        this.temData.template.template_id || this.temData.template.id,
        loading
      ).then((res: any) => {
        const d: any = [];
        res.data.fields.forEach((element: any) => {
          if (
            element.type != "标题" &&
            element.type != "主标题" &&
            element.type != "段落标题"
          ) {
            if (element.type == "动态表格" || element.type == "动态数组") {
              element.basic.forEach((ele: any) => {
                d.push({
                  key: ele.field_oid || ele.title,
                  title: ele.title,
                  origin: "",
                  is_time_key: false,
                });
              });
            } else {
              d.push({
                key: element.field_oid,
                title: element.title,
                origin: "",
                is_time_key: false,
              });
            }
          }
        });
        this.temData.headers = d;
      });
    });
  }
  private openAdd(item?: any) {
    if (item) {
      this.editData = JSON.parse(JSON.stringify(item));
    } else {
      this.editData = {
        codes: [],
        plans: [],
      };
    }
    this.ifShowAdd = true;
  }
  private addCode() {
    this.editData.codes.push({});
  }
  private delCode(index: any) {
    this.$confirm("您是否确定删除当前内容？", "删除", {
      customClass: "commonConfirm",
    }).then(() => {
      this.editData.codes.splice(index, 1);
    });
  }
  private delPlan(index: any) {
    this.$confirm("您是否确定删除当前内容？", "删除", {
      customClass: "commonConfirm",
    }).then(() => {
      this.editData.plans.splice(index, 1);
    });
  }
  private openAddPlan(item?: any, index?: any) {
    this.planData = {};
    if (item) {
      this.planData = {
        name: item.name,
        index: index,
      };
    }
    this.ifShowAddPlan = true;
  }
  private addPlanSure() {
    // 判断新增还是编辑
    if (!this.planData.index && this.planData.index !== 0) {
      // 新增
      this.editData.plans.push({
        name: this.planData.name,
      });
    } else {
      // 编辑
      this.editData.plans[this.planData.index].name = this.planData.name;
    }
    this.ifShowAddPlan = false;
  }
  private planChange(item: any) {
    item.children = [];
    if (!item.plan_id) {
      return;
    }
    GetPlanTem(this, item.plan_id).then((res: any) => {
      item.children = res.data;
      this.$forceUpdate();
    });
  }
  private save() {
    if (!this.editData.name) {
      this.$message.warning("请输入病种名称");
      return;
    }
    if (!this.editData.codes || this.editData.codes.length == 0) {
      this.$message.warning("请关联出院西医诊断编码");
      return;
    }
    if (!this.editData.plans || this.editData.plans.length == 0) {
      this.$message.warning("请添加导出数据范围");
      return;
    }
    if (this.editData.id) {
      const loading = this.$loading({
        lock: true,
        text: "加载中……",
        spinner: "el-icon-loading",
        customClass: "loadClass",
        background: "rgba(255, 255, 255, 0.7)",
      });
      PatchBingzhong(this, this.editData.id, this.editData, loading).then(
        (res: any) => {
          this.$message.success("保存成功");
          this.ifShowAdd = false;
          this.getList();
        }
      );
    } else {
      const loading = this.$loading({
        lock: true,
        text: "加载中……",
        spinner: "el-icon-loading",
        customClass: "loadClass",
        background: "rgba(255, 255, 255, 0.7)",
      });
      PostAddBingzhong(this, this.editData, loading).then((res: any) => {
        this.$message.success("保存成功");
        this.ifShowAdd = false;
        this.getList();
      });
    }
  }
  private getPlans() {
    const params: any = {
      params: {
        is_suifanglei: false,
      },
    };
    GetPlanData(this, params).then((res: any) => {
      this.plans = res.data;
    });
  }
  private getList() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    GetExportManagementAll(this, loading).then((res: any) => {
      this.data = res.data;
    });
  }
  private mounted() {
    this.getPlans();
    this.getList();
  }
}
